<spark-shared-data-table-wrapper
  [title]="title"
  [downloading]="downloading"
  (downloadClicked)="downloadClicked()">
  <ng-container table-definition>
    <div class="row" *appLoad="let data of data$">
      <div class="col">
        <div class="row mb-3">
          <div class="col">
            <ngx-datatable
              [rows]="data.data"
              [reorderable]="true"
              [swapColumns]="false"
              rowHeight="auto"
              columnMode="force"
              *ngIf="data">
              <ngx-datatable-column name="Adviser" prop="adviser">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Client Full Name">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <a [href]="contactBaseUrl + row.clientId" target="_blank">{{
                    row.clientFullName
                  }}</a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                name="Fixed Maturity Date"
                prop="fixedMaturityDate">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value | date : 'dd/MM/yyyy' }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                name="IO Maturity Date"
                prop="ioMaturityDate">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value | date : 'dd/MM/yyyy' }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Interest Rate" prop="interestRate">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value | percent : '1.2' }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Lender" prop="provider">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-end">
            <spark-shared-pagination
              [currentPage]="data.pagination.currentPage"
              [size]="data.pagination.pageSize"
              [count]="data.pagination.totalItems"
              (gotoPage)="
                pageChanged($event, data.pagination.pageSize)
              "></spark-shared-pagination>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</spark-shared-data-table-wrapper>
